import React from "react";

const Footer = () => {
  return (
    <div
      className="d-flex  align-items-center flex-column gap-3"
      style={{ background: "#F8F8F8", padding: "20px" }}
    >
      <b>Contact Details</b>
      <div>
        <b>Address: </b> 30N Gould St #37255 Sheridan Wyoming 82801
      </div>
      <div>
        <b>Contact: </b> (386) 951-4245
      </div>
      <div>
        <b>Email: </b> sales@humayunllc.com
      </div>
    </div>  
  );
};

export default Footer;
